import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 시리즈 좋아요 설정
 *
 * Origin: pageNicolasApi.setSeriesLike
 * API: POST /api/v6/store/set/serieslike
 */
export async function postStoreSetSeriesLike(
  {
    series_id,
    state,
  }: {
    series_id: number;
    state: boolean;
  },
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v6/store/set/serieslike',
    {
      method: 'POST',
      data: {
        // API 스펙이 snake_case 대신 seriesid를 요구
        seriesid: series_id,
        state,
      },
    },
    options
  );

  return response.data;
}
